import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

const ReferralOutboundPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound')
);

const CreateReferralWizard = loadable(
  () => import('@/pages/CRM/ReferralOutbound/CreateReferralWizard')
);

const PartnerPortalPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound/PartnerPortal')
);

const ReferralManagementPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound/ReferralManagement')
);

const ProviderSearchPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound/ProviderSearch')
);

const RecipientConfigurationPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound/RecipientConfiguration')
);

const CalendarPage = loadable(
  () => import('@/pages/CRM/ReferralOutbound/Calendar')
);

export enum CRMReferralOutboundRoutes {
  CRMReferralOutbound = '/crm/referral-outbound',
  CRMReferralOutboundSend = '/crm/referral-outbound/send',
  CRMReferralOutboundPartner = '/crm/referral-outbound/partner/:providerId',
  CRMReferralOutboundManagement = '/crm/referral-outbound/:referral_id',
  CRMReferralOutboundProviderSearch = '/crm/referral-outbound/provider-search',
  CRMReferralOutboundRecipientConfiguration = '/crm/referral-outbound/recipient-configuration',
  CRMReferralOutboundCalendar = '/crm/calendar'
}

export const getCrmReferralOutboundRoutes = (): RouteObject[] => {
  if (!FeatureFlagService.isEnabled(ExacareFeature.CRM_REFERRAL_OUTBOUND)) {
    return [];
  }
  return [
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutbound,
      element: <ReferralOutboundPage />
    },
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutboundSend,
      element: <CreateReferralWizard />
    },
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutboundPartner,
      element: <PartnerPortalPage />
    },
    ...(FeatureFlagService.isEnabled(ExacareFeature.CRM_PROVIDER_SEARCH)
      ? [
          {
            path: CRMReferralOutboundRoutes.CRMReferralOutboundProviderSearch,
            element: <ProviderSearchPage />
          },
          {
            path: CRMReferralOutboundRoutes.CRMReferralOutboundRecipientConfiguration,
            element: <RecipientConfigurationPage />
          }
        ]
      : []),
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutboundCalendar,
      element: <CalendarPage />
    },
    {
      path: CRMReferralOutboundRoutes.CRMReferralOutboundManagement,
      element: <ReferralManagementPage />
    }
  ];
};
